import React, { Component, useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import RegisterForm from "../RegisterForm/RegisterForm";
import { Carousel } from 'primereact/carousel';
import "./RegisterPage.css";
import { Div, DivRow, DivImg, Img, Form } from "./RegisterPage.styles";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Register
Description : Vista definida para la primera parte del proceso de registro
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa la vista del formulario de registro
================================================================================ */

export default function RegisterPage() {

    const [tiempo, setTiempo] = useState(300);

    setTimeout(function () {
        console.log('hola');
        setTiempo(400);
    }, 3000)

    const time = () => {

        console.log('tiempo')
        return 3000;
    }

    const products = [
        {
            id: 0,
            image: localStorage.getItem('LOGIN_VIDEO'),
            name: 'Remuner',
            type: 'vid'
        },
        {
            id: 1,
            image: process.env.REACT_APP_BANNER_IMAGE_1,
            name: 'Remuner',
            type: 'img'
        },
        {
            id: 2,
            image: process.env.REACT_APP_BANNER_IMAGE_2,
            name: 'Remuner',
            type: 'img'
        },
        {
            id: 3,
            image: process.env.REACT_APP_BANNER_IMAGE_3,
            name: 'Remuner',
            type: 'img'
        }
    ]

    const productTemplate = (product) => {
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="mb-3">
                        {
                            product.type === 'img' ?
                                <a href="#" target="_blank" rel="noopener noreferrer">
                                    <Img src={product.image} alt={product.name} />
                                </a>
                                :
                                <div className='w-18rem align-content-end pb-0 -mr-6'>
                                    <iframe
                                        width="840"
                                        height="460"
                                        style={{ marginTop: '3rem', marginBottom: '-2rem' }}
                                        src={product.image}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title="Embedded youtube"
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Div style={{ backgroundColor: "white" }}>
            <div className="container">
                <DivRow>
                    <div className="carousel-demo">
                        <div style={{ marginLeft: "-6rem" }} className="card">
                            <Carousel value={products} numVisible={1} numScroll={1} circular
                                autoplayInterval={3000} itemTemplate={productTemplate} header={false} />
                        </div>
                    </div>
                    <Form>
                        <RegisterForm className="mr-4" />
                    </Form>
                </DivRow>
            </div>
        </Div>
    )
}